export const ADMIN_API_BASE_URL = "https://backend.rajasreetownships.in";
// export const ADMIN_API_BASE_URL = "http://localhost:8080";
